<mat-accordion class="mat-elevation-z0">
  <mat-expansion-panel class="mat-elevation-z0" hideToggle>

    <mat-expansion-panel-header>
      <mat-panel-title>
        <button mat-button><mat-icon>add</mat-icon> Add Email</button>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="mat-elevation-z1" style="padding:10px">
      <mat-form-field appearance="outline" style="padding-left: 3px;">
        <mat-label>First Name</mat-label>
        <input matInput name="fname" [(ngModel)]="newEmail.Firstname">
      </mat-form-field>

      <mat-form-field appearance="outline" style="padding-left: 3px;">
        <mat-label>Last Name</mat-label>
        <input matInput name="lname" [(ngModel)]="newEmail.Lastname">
      </mat-form-field>

      <mat-form-field appearance="outline" style="padding-left: 3px;">
        <mat-label>E-Mail</mat-label>
        <input matInput name="email" [(ngModel)]="newEmail.email">
      </mat-form-field>

      <mat-form-field appearance="outline" style="padding-left: 3px;" (click)="loadEmailGroups()">
        <mat-label>Group</mat-label>
        <mat-select [(value)]="newEmail.group" >
          <mat-option *ngFor="let group of EmailGroups" [value]="group.group">
            {{group.group}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="padding-left: 3px;">
        <mat-label>Entity</mat-label>
        <input matInput name="Entity" [(ngModel)]="newEmail.Entity">
      </mat-form-field>

      <br />
      <button mat-stroked-button (click)="saveEmail()"><mat-icon>save</mat-icon> SAVE</button>
    </div>



  </mat-expansion-panel>

</mat-accordion>
